import { Menu } from '@app/types';
import menusJSON from './menus.json';

// @ts-ignore
export const fakeMenus = menusJSON.menus as Menu[];
